import type {VirtualClinicAnalysisOperatingNumberGroupBy} from './group-by';
import type {VirtualClinicAnalysisOperatingNumberGroupByOption} from './group-by-option';
import type {VirtualClinicAnalysisGroupByDictionary} from './dictionary';

export class VirtualClinicAnalysisOperatingNumberGroupByHelper {
  public static createDictionary(
    availableGroupByOptions: VirtualClinicAnalysisOperatingNumberGroupByOption[]
  ): VirtualClinicAnalysisGroupByDictionary {
    const dictionary = {
      fieldNames: {},
      parameters: {},
      parameterValues: {},
      aggregations: {},
      categories: {},
    };

    availableGroupByOptions.forEach((option) => {
      dictionary.fieldNames[option.fieldName] = option.displayName;
      option.possibleParameters.forEach((possibleParameter) => {
        dictionary.parameters[possibleParameter.name] =
          possibleParameter.displayName;

        (possibleParameter.possibleValues || []).forEach((possibleParameterValue) => {
          dictionary.parameterValues[possibleParameterValue.value] =
            possibleParameterValue.displayName;
        });
      });

      option.possibleAggregations.forEach((possibleAggregation) => {
        dictionary.aggregations[possibleAggregation.name] =
          possibleAggregation.displayName;
      });

      dictionary.categories[option.category?.id] = option.category?.displayName;
    });

    return dictionary;
  }

  public static normalize(
    groupBy: VirtualClinicAnalysisOperatingNumberGroupBy
  ): VirtualClinicAnalysisOperatingNumberGroupBy {
    const cleanEmpty = (obj) => {
      if (Array.isArray(obj)) {
        return obj
          .map((v) => (v && typeof v === 'object' ? cleanEmpty(v) : v))
          .filter((v) => !(v == null));
      } else {
        return Object.entries(obj)
          .map(([k, v]) => [k, v && typeof v === 'object' ? cleanEmpty(v) : v])
          .reduce((a, [k, v]) => {
            if (v === null || v === undefined) {
              return a;
            }

            if (typeof v === 'object' && Object.keys(v).length === 0) {
              return a;
            }

            return (a[k] = v), a;
          }, {});
      }
    };

    return cleanEmpty(groupBy) as VirtualClinicAnalysisOperatingNumberGroupBy;
  }

  public static valid(
    groupBy: VirtualClinicAnalysisOperatingNumberGroupBy
  ): boolean {
    const validAggregation =
      !!groupBy.aggregation && !!groupBy.aggregation.name;
    return !!groupBy.fieldName && validAggregation;
  }

  public static toRequestData(
    groupBy: VirtualClinicAnalysisOperatingNumberGroupBy[] | null
  ): Omit<VirtualClinicAnalysisOperatingNumberGroupBy, 'parameters'>[] | null {
    if (!groupBy) {
      return null;
    }

    return groupBy.map((item) => {
      const result: VirtualClinicAnalysisOperatingNumberGroupBy = {
        ...this.normalize(item),
      };

      return result;
    });
  }
}
